import { Skeleton } from 'antd'
import { AssetVisualizationPanel } from 'features/libra/stepComponents/niiReport/cards/AssetVisualizationPanel'
import { StyledCard } from 'features/libra/stepComponents/niiReport/cards/cardsStyles'
import { useNiiReportData } from 'features/libra/stepComponents/niiReport/NiiReportDataContext'
import { FC } from 'react'

export const NiiInspectionsCard: FC = () => {
  const { isLoading } = useNiiReportData()

  return isLoading ? (
    <Skeleton active paragraph={{ rows: 3 }} />
  ) : (
    <StyledCard title='Asset Visualization'>
      <AssetVisualizationPanel />
    </StyledCard>
  )
}
